import { defineAsyncComponent } from 'vue'
export default {
  clean: defineAsyncComponent(() => import("/home/vsts/work/1/s/layouts/clean.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/home/vsts/work/1/s/layouts/default.vue").then(m => m.default || m))
}